// extracted by mini-css-extract-plugin
export default {"avatar":"BotAvatar_avatar__xpSQ4"};